module.exports = __webpack_public_path__ + "img/Comorbidity_Transplant.3428eebc.jpg";